import React from 'react'

interface Props {
    disabled?: boolean,
    title: string,
    isLoading?: boolean
    id?: string;
    type?: 'button' | 'reset' | 'submit' | undefined
    layout?: 'green' | 'blue';
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const Button: React.FC<Props> = ({ isLoading, disabled, layout = 'green', title, type, id, onClick }) => {

    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // Only perform onClick if the button isn't disabled or is loading
        if ( !disabled && !isLoading) {
            onClick(event)
        }
    }

    const getButtonClass = () => {
        switch (layout) {
            case 'green':
                return 'membership-app__button';
            case 'blue':
                return 'membership-app__button-blue';
        }
    }

    if ( isLoading ) {
        return (
            <button
                id={id}
                type={type}
                onClick={handleOnClick}
                className={`button ${getButtonClass()} membership-app__button--loading`}
                disabled={true}>
                {title}
            </button>
        )
    }

    return (
        <button 
            type={type} 
            id={id}
            onClick={handleOnClick} 
            className={`button ${getButtonClass()}`} 
            disabled={disabled}>
                {title}
        </button>
    )

}

Button.defaultProps = {
    disabled: false,
    type: 'button',
    isLoading: false
}